import React, { useContext, useEffect, useRef, useState } from 'react'
import { WebsiteContext } from './WebsiteContext';
import Home from '../scenes/Website/Home/Home';
import MusicChannel from '../scenes/Website/Channels/MusicChannel';
import RoyaleChannel from '../scenes/Website/Channels/RoyaleChannel';
import SelectChannel from '../scenes/Website/Channels/SelectChannel';
import PlanetaChannel from '../scenes/Website/Channels/PlanetaChannel';
import PageSwiper from '../scenes/Website/Home/PageSwiper';
import { useSwipeable } from 'react-swipeable';
import { AppContext } from './AppContext';
const ROUTES = [
    "home",
    "pmcMusicChannel",
    "pmcRoyaleChannel",
    "pmcSelectRadio",
    "pmcPlanetaRadio"
];
export const PageContext = React.createContext({})

export const PageContextProvider = ({ children, page }) => {
    const websiteContext = useContext(WebsiteContext);
    const appContext = useContext(AppContext);
    const [lastPage, setLastPage] = useState(null);
    const [waitPage, setWaitPage] = useState(null);
    const [hidePage, setHidePage] = useState(null);
    const [activePage, setActivePage] = useState(page);
    useEffect(() => {
      if(websiteContext.page !== null){
          if(waitPage){
              websiteContext.setIsShowBackVideo(true)
          }
      }
    }, [waitPage])
    useEffect(() => {
      if(websiteContext.page){
          if(websiteContext.page !== activePage){
              // setShowMenu(false);
              setHidePage(activePage);
              setWaitPage(websiteContext.page);
          }else{
              websiteContext.setIsPageLoaded(false)
              setActivePage(page)
          }
      }else{
          websiteContext.setIsPageLoaded(false)
          setActivePage(page)
      }
      const preventDefault = (e) => {
          if (window.scrollY === 0 && e.touches[0].clientY > 10) {
              e.preventDefault();
          }
      };
      if(websiteContext.page && websiteContext.page !== "home")
          document.addEventListener("touchmove", preventDefault, { passive: false });
      
      return () => {
          if(websiteContext.page && websiteContext.page !== "home")
              document.removeEventListener("touchmove", preventDefault);
      };
      
    }, [websiteContext.page]);
    const onHidedPage = () => {
        setLastPage(hidePage)
        setHidePage(null);
        setActivePage(waitPage);
        setWaitPage(null);
        // setLastTouch(null);
    }
    const handlers = useSwipeable({
        onSwipedLeft: (e) => {
            if(!appContext.isLandscape) return;
            handleChangeNextPage(e)
        },
        onSwipedRight: (e) => {
            if(!appContext.isLandscape) return;
            handleChangePrevPage(e)
        },
        onSwipedUp: (e) => {
            if(appContext.isLandscape) return;
            handleChangePrevPage(e)
        },
        onSwipedDown: (e) => {
            if(appContext.isLandscape) return;
            handleChangeNextPage(e)
        },
        delta: 10,
        trackTouch: true,
        trackMouse: false
    });
    const handleChangePage = (pageName) => {
        document.getElementById(`menu-${pageName}`).click()
    }

    const handleChangeNextPage = (e) => {
        let index = 1;
        if(ROUTES.indexOf(activePage) < (ROUTES.length - 1))
            index = ROUTES.indexOf(activePage) + 1;
        const nextPage = ROUTES[index];
        handleChangePage(nextPage);
    }
    const handleChangePrevPage = (e) => {
        let index = ROUTES.length - 1;
        if(ROUTES.indexOf(activePage) > 1)
            index = ROUTES.indexOf(activePage) - 1;
        const prevPage = ROUTES[index];
        handleChangePage(prevPage);
    }

    const onFinishAnimation = () => {
        websiteContext.setIsPageLoaded(true);
    }


    return (
      <PageContext.Provider value={{
          lastPage,
          waitPage,
          activePage,
          hidePage,
          swipeHandlers: handlers,
          setLastPage,
          setWaitPage,
          setActivePage,
          setHidePage,
          onFinishAnimation,
          onHidedPage
        }}
      >
        {children}
      </PageContext.Provider>
    );
  };